module.exports = __webpack_public_path__ + "static/media/de.97d705b0.svg";